import { FullScreenFormWrapper } from 'src/Containers/FullScreenFormWrapper';
import useFetchExport from 'src/Hooks/Queries/useFetchExport';

import { ExportedPracticalInformationWrapper } from './ExportedPracticalInformationWrapper';

interface Props {
  token: string;
}

const ExportPracticalInformationPage = ({ token }: Props) => {
  const { data } = useFetchExport(token);
  return (
    <FullScreenFormWrapper>
      {data?.entityIds?.map(entityId => (
        <ExportedPracticalInformationWrapper
          key={entityId}
          token={token}
          practicalInformationId={entityId}
        />
      ))}
    </FullScreenFormWrapper>
  );
};

export default ExportPracticalInformationPage;
